import React from 'react';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import 'focus-within-polyfill';
import ImageWrapper from '../../react/ImageWrapper';
import { RoutableRichText } from '../../react/RoutableRichText';
import { RoutableLink } from '../../react/RoutableLink';
import { ArticleDate } from '../../react/ArticleDate';
import css from './index.module.scss';

const MomentBoxInner = (props) => (
  <>
    {
      props.date &&
      <ArticleDate field={props.date} tag='small' className={css.date} />
    }
    {
      props.description?.value &&
      <RoutableRichText field={props.description} className={css.description} />
    }
    {
      (props.link?.value?.href && props.linkText?.value) &&
      <Text field={props.linkText} tag='p' className={css.link} data-chevron={true} />
    }
  </>
)

const MomentBoxShell = (props) => (
  <div className={css.box}>
    {
      props?.item?.fields?.image?.value?.src &&
      <ImageWrapper image={props.item.fields.image} className={css.image} gif={props.item.fields.gif} />
    }
    {
      (props?.item?.fields?.link?.value?.href && props?.item?.fields?.linkText?.value) ?
        <a href={props.item.fields.link.value.href}
          className={css.hoverContainer}
          tabIndex={0}
          aria-label={`Read more about '${props.item.fields.description?.value?.replace(/(<([^>]+)>)/gi, "")}'`}>
          <MomentBoxInner
            date={props.item.fields.date}
            description={props.item.fields.description}
            link={props.item.fields.link}
            linkText={props.item.fields.linkText} />
        </a>
        :
        <div className={css.hoverContainer} tabIndex={0}>
          <MomentBoxInner
            date={props.item.fields.date}
            description={props.item.fields.description} />
        </div>
    }
  </div>
)

const Moments = ({ fields }) => (
  fields?.children &&
  <section className={`${css.container} single-col-inner`}>
    <div className={css.headerContainer}>
      {
        fields?.title?.value &&
        <Text className={`${css.title} sans-head-2`} tag='h2' field={fields?.title} />
      }
      {
        (fields?.link?.value?.href && fields?.linkText?.value) &&
        <RoutableLink field={fields?.link} className={css.cta}>
          <Text field={fields?.linkText} />
        </RoutableLink>
      }
    </div>
    <div className={`${css.photosContainer} ${fields.hasBackground?.value ? css.hasBackground : ''}`}>
      {
        fields.children.slice(0, 1).map((item, index) =>
          <div key={`moment-col-${index}`}>
            <MomentBoxShell item={item} index={index} />
          </div>
        )
      }
      <div className={css.boxGroup}>
        {
          fields.children.slice(1, 5).map((item, index) =>
            <MomentBoxShell key={`moment-box-${index}`} item={item} index={index} />
          )
        }
      </div>
    </div>
  </section>
);

export default Moments;